import { Trans } from "@lingui/react/macro";
import styles from "./index.module.scss";
import { Outlet } from "react-router";
import { NavLink } from "react-router";
import AvatarIcon from "@medoma/components/icons/AvatarIcon";
import CalendarIcon from "@medoma/components/icons/CalendarIcon";
import MultiplePersonsIcon from "@medoma/components/icons/MultiplePersonsIcon";

export const TabsView = () => {
  return (
    <>
      <div className={styles.outlet}>
        <Outlet />
      </div>
      <div className={styles.navBar}>
        <NavLink to="routesAndActivities" className={styles.navItem}>
          <CalendarIcon />
          <Trans>Mitt arbetspass</Trans>
        </NavLink>
        <NavLink to="patients" className={styles.navItem}>
          <AvatarIcon />
          <Trans>Patienter</Trans>
        </NavLink>
        <NavLink to="coworkers" className={styles.navItem}>
          <MultiplePersonsIcon />
          <Trans>Medarbetare</Trans>
        </NavLink>
      </div>
    </>
  );
};
